export default class CalendarModel {
  public calendarId = "";
  public userId = "";
  public title = "";

  constructor(data?: any) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
